export const BestandView5Headers = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. FKB',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'KBD',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'KFD',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DGAPI KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'FP Freischaltung',
        mouseOver: 'Projekt Freischaltung',
    },
    {
        id: 9,
        title: 'FP Briefing erfolgt',
        mouseOver: 'Projektbriefing erfolgt',
    },
    {
        id: 10,
        title: 'FP-Start fix',
        mouseOver: 'Projektbriefing erfolgt',
    },
    {
        id: 11,
        title: 'FP Abschluss Umsetzung',
        mouseOver: 'Projektabschluss Umsetzung',
    },
    {
        id: 12,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]

export const BestandView5HeadersDgg = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. CL',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'ADM',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'KGSL',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DG KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'FP Freischaltung',
        mouseOver: 'Projekt Freischaltung',
    },
    {
        id: 9,
        title: 'FP Briefing erfolgt',
        mouseOver: 'Projektbriefing erfolgt',
    },
    {
        id: 10,
        title: 'FP-Start fix',
        mouseOver: 'Projektbriefing erfolgt',
    },
    {
        id: 11,
        title: 'FP Abschluss Umsetzung',
        mouseOver: 'Projektabschluss Umsetzung',
    },
    {
        id: 12,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]